import type { PartnerFormCopy, ResolvedPartnerFormCopy } from "./types";

/** COM-737 acceptance-criteria copy, verbatim; the failure line is retry-friendly by AC. */
export const DEFAULT_SUBMIT_LABEL = "Contact Our Team";
export const DEFAULT_SUCCESS_MESSAGE =
  "Thanks for submitting a request! A member of our partnerships team will be in touch soon.";
export const DEFAULT_FAILURE_MESSAGE =
  "We couldn't send your request just now. Please try again.";

const pick = (value: string | undefined, fallback: string): string =>
  value !== undefined && value.trim() !== "" ? value : fallback;

export function resolvePartnerFormCopy(
  copy: PartnerFormCopy | undefined,
): ResolvedPartnerFormCopy {
  return {
    submitLabel: pick(copy?.submitLabel, DEFAULT_SUBMIT_LABEL),
    successMessage: pick(copy?.successMessage, DEFAULT_SUCCESS_MESSAGE),
    failureMessage: pick(copy?.failureMessage, DEFAULT_FAILURE_MESSAGE),
  };
}
